export const selectAppData = (state) => state.appData
